export const customMarkersSelector = ({customMarkers}) => customMarkers;
